<template lang="pug">
  v-dialog(v-model="show", v-if="estabelecimento", width="50%", max-height="70%")
    v-card.Poppins
      v-card-title.font-weight-semibold.Poppins(style="font-size:20px;") Fechar {{ estabelecimento.nome}}
      v-card
        v-card-text
          v-layout(row, wrap)
            v-flex.md12
              span.subheading Por favor, selecione a duração do fechamento:
              v-radio-group(v-model="tempoDeFechamento")
                v-radio(:disabled="!dataCasoProximoHorario || !proximoTurnoVigente" :label="'Até o próximo horário de abertura: ' + (dataCasoProximoHorario && proximoTurnoVigente ? proximoTurnoVigente : '')" :value="0")
                v-radio(label="Por 15 Minutos", :value="1")
                v-radio(label="Por 1 Hora", :value="2")
                v-radio(label="Por 2 Horas", :value="3")
        v-card-actions
          v-spacer
          v-btn(@click="close()", flat) Cancelar
          v-btn.white--text(depressed, :loading="loading", :disabled="tempoDeFechamento == null", @click="apply();", color="primary") CONFIRMAR
  
</template>

<script>
import _ from "lodash";

export default {
  components: {
  },
  props: {
  },
  data () {
    return {
        show : false,
        loading: false,
        estabelecimento: null,
        proximoTurnoVigente: null,
        dataCasoProximoHorario: null,
        tempoDeFechamento: null
    }
  },
  created () {
  },
  mounted() {
  },
  watch: {
  },
  computed: {
    estabelecimentos(){
      return _.sortBy(this.$root.estabelecimentos, 'nome')
    },
    estabelecimentoSelecionado(){
      return this.$root.estabelecimentoSelecionado;
    }
  },
  methods: {
    showErrorMsg(error, defaultMsg){
      let err = error.response && error.response.data ? error.response.data.error : defaultMsg;
      window.getApp.$emit("APP_ALERT", {
          color: "red",
          text: err,
      });
    },
    async open(estabelecimento){
      this.estabelecimento = estabelecimento;
      this.show = true;
      this.tempoDeFechamento = null;
      this.dataCasoProximoHorario = null;
      this.proximoTurnoVigente = null;
      await this.getHorarioFuncionamento(this.estabelecimento)
    },
    close(){
      this.show = false;
    },
    update(delivery){
      this.estabelecimento.delivery[0] = delivery;
      
      if(this.estabelecimentoSelecionado && this.estabelecimentoSelecionado.id == this.estabelecimento.id)
        this.$store.dispatch('setEstabelecimentoSelecionado', this.estabelecimento);
      
      const index = _.findIndex(this.estabelecimentos, (o)=>{
        return o.id == this.estabelecimento.id;
      })
      this.estabelecimentos[index] = this.estabelecimento;
      this.$store.dispatch('setEstabelecimentos', this.estabelecimentos);
      
      this.$emit('refresh', this.estabelecimento)
    },
    async apply(){
      if(!this.estabelecimento && this.estabelecimento.delivery && this.estabelecimento.delivery[0]) return;
      
      try {
        this.loading = true;

        const minutosParaAdicao = [0, 15, 60, 120];
        // 0 - Até o próximo horário de abertura
        // 1 - Por 15 Minutos
        // 2 - Por 1 Hora
        // 3 - Por 2 Horas
        const delivery = this.estabelecimento.delivery[0];
        
        const recesso = {
          estabelecimento_id: this.estabelecimento.id,
          ativo: 1,
          data_inicio: this.$dayjs().format('YYYY-MM-DD HH:mm:ss'),
          data_fim: this.tempoDeFechamento == 0 ? this.$dayjs(this.dataCasoProximoHorario).format('YYYY-MM-DD HH:mm:ss') : this.$dayjs().add(minutosParaAdicao[this.tempoDeFechamento], 'minutes').format('YYYY-MM-DD HH:mm:ss'),
        };
        
        const response = await this.$axios.post('/fechar', {
            recesso, 
            delivery
        });
        console.log('apply', response.data);
        this.update(response.data);
        this.loading = false;
        this.close()
      } catch (error) {
        this.showErrorMsg(error, 'Ocorreu um erro ao fechar a loja. Atualize a página!')
        this.loading = false;
      }
    },
    async getHorarioFuncionamento(estabelecimento){
      try {
        if (!estabelecimento.id) return;
        this.loading = true;
        
        const response = await this.$axios.get('/horario-funcionamento', {
          params: {
            estabelecimento_id: estabelecimento.id,
            ativo: 1
          }
        });

        this.horarios = response.data;
        this.proximoTurnoVigente = this.proximoTurno(this.horarios)
        this.loading = false;
      } catch (error) {
        this.showErrorMsg(error, 'Ocorreu um erro ao buscar as horários. Atualize a página!')
        this.loading = false;
      }
    },

    proximoTurno(horarios){
      const vm = this;
      let horarioAtual = vm.$dayjs().format('HH:mm');
      let diaAtual = vm.$dayjs().day();

      let turnosDoDia = [];
      let horario;

      for (let i = diaAtual; i < 7; i++) {
        let diaConsiderado = i;

        if(diaConsiderado == diaAtual) {
          turnosDoDia = horarios.filter(turno => {
            return turno.dia_semana == diaConsiderado && turno.ativo == 1 &&
              ((turno.horario_inicio_1 && vm.$dayjs(horarioAtual, 'HH:mm').isBefore(vm.$dayjs(turno.horario_inicio_1, 'HH:mm'))) ||
              (turno.horario_inicio_2 && vm.$dayjs(horarioAtual, 'HH:mm').isBefore(vm.$dayjs(turno.horario_inicio_2, 'HH:mm'))));
          });
        } else {
          turnosDoDia = horarios.filter(turno => {
            return turno.dia_semana == diaConsiderado && turno.ativo == 1 && (turno.horario_inicio_1 || turno.horario_inicio_2);
          });
        }

        if(turnosDoDia && turnosDoDia.length) {
          break;
        }
      }

      if (turnosDoDia && turnosDoDia.length == 0) {
        for (let i = 0; i < diaAtual; i++) {
          let diaConsiderado = i;

          turnosDoDia = horarios.filter(turno => {
            return turno.dia_semana == diaConsiderado && turno.ativo == 1 && (turno.horario_inicio_1 || turno.horario_inicio_2);
          });

          if(turnosDoDia && turnosDoDia.length) {
            break;
          }
        }
      }

      let proximoHorario1 = turnosDoDia[0].horario_inicio_1 && vm.$dayjs(turnosDoDia[0].horario_inicio_1, 'HH:mm').isAfter(vm.$dayjs(horarioAtual, 'HH:mm')) ? turnosDoDia[0].horario_inicio_1 : null;
      let proximoHorario2 = turnosDoDia[0].horario_inicio_2 && vm.$dayjs(turnosDoDia[0].horario_inicio_2, 'HH:mm').isAfter(vm.$dayjs(horarioAtual, 'HH:mm')) ? turnosDoDia[0].horario_inicio_2 : null;

      if (proximoHorario1 && proximoHorario2) {
          horario = vm.$dayjs(proximoHorario1, 'HH:mm').isBefore(vm.$dayjs(proximoHorario2, 'HH:mm')) ? proximoHorario1 : proximoHorario2;
      } else {
          horario = proximoHorario1 || proximoHorario2 || turnosDoDia[0].horario_inicio_1 || turnosDoDia[0].horario_inicio_2;
      }

      let diaSemana = ["Domingo", "Segunda", "Terça", "Quarta", "Quinta", "Sexta", "Sábado"][turnosDoDia[0].dia_semana % 7];
      let diaDeHoje = vm.$dayjs().day();

      if(diaDeHoje <= turnosDoDia[0].dia_semana){
        vm.dataCasoProximoHorario = vm.$dayjs().day(turnosDoDia[0].dia_semana).hour(Number(horario.split(':')[0])).minute(Number(horario.split(':')[1])).format('YYYY-MM-DD HH:mm:ss');
      } else {
        let proximaData = vm.$dayjs().day(turnosDoDia[0].dia_semana).hour(Number(horario.split(':')[0])).minute(Number(horario.split(':')[1]));
        proximaData = proximaData.add(7, 'day');
        vm.dataCasoProximoHorario = proximaData.format('YYYY-MM-DD HH:mm:ss');
      }
      return `${diaSemana} às ${horario} horas`;
    },
  }
}
</script>

<style lang="scss" scoped>
.content-text{
  white-space: normal; 
  word-wrap: break-word; 
  height: auto;
}
</style>
